import styled from 'styled-components';

export const SkeletonWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    height: auto;
    padding: 10px;
    top: 40px;
    z-index: 200;
    position: absolute;
    background: ${({ theme }) => theme.colors.card.background};
`;
